<app-c-barre-nav></app-c-barre-nav>
<router-outlet></router-outlet>
<app-mentions-legales></app-mentions-legales>
